module.exports = __webpack_public_path__ + "img/Guangdong-speed.5f9d20a0.png";